// Face sign-in: the Admin /face calls (header X-Admin-Pin).
//
// They use the same mechanism as the night-watch pages: utils/securityApi.js securityFetch adds
// the admin session's PIN (sessionStorage adminPin). Setting up a station can instead send a PIN
// typed for that one call, so a station computer never has to be left in an admin session.
// Every helper resolves {ok, status, body, message} and never throws.

import { beaconFetch } from '../utils/beacons';
import { securityFetch } from '../utils/securityApi';
import { invalidateStationStatus } from './faceStation';

function adminFetch(path, opts = {}, adminPin = null) {
  if (adminPin) {
    return beaconFetch(path, { ...opts, headers: { ...(opts.headers || {}), 'X-Admin-Pin': adminPin } });
  }
  return securityFetch(path, opts);
}

const post = (body) => ({ method: 'POST', body: JSON.stringify(body || {}) });

/** POST /face/stations {name} -> {station_id, name, station_key}. `adminPin` = a PIN typed for this call. */
export function createStation(name, { adminPin = null } = {}) {
  return adminFetch('/face/stations', post({ name }), adminPin);
}

/** GET /face/stations -> {stations: [...]} */
export function listStations() {
  return adminFetch('/face/stations');
}

/** POST /face/stations/{id}/revoke */
export async function revokeStation(stationId) {
  const r = await adminFetch(`/face/stations/${encodeURIComponent(stationId)}/revoke`, post({}));
  if (r.ok) invalidateStationStatus();
  return r;
}

/** GET /face/enrollments -> {enrollments: [...], not_enrolled: [...]} */
export function listEnrollments() {
  return adminFetch('/face/enrollments');
}

/** POST /face/enrollments/{user_id}/remove */
export function removeEnrollment(userId) {
  return adminFetch(`/face/enrollments/${encodeURIComponent(userId)}/remove`, post({}));
}

/** GET /face/summary?days=7 */
export function faceSummary(days = 7) {
  return adminFetch(`/face/summary?days=${encodeURIComponent(days)}`);
}
